const typeArr = ['primary', 'info', 'success', 'warning', 'purple']

export default {
    props: {
        index: {
            type: Number
        }
    },
    computed: {
        typeClass () {
            return typeArr[this.index % typeArr.length]
        }
    },
    methods: {
        getTypeClass (index) {
            return typeArr[index % typeArr.length]
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/typeClass.js